import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyHome = lazyWithRetry(() => import("./Error404"));

const Home = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyHome {...props} />;

export default Home;
